import { ApolloCache, Reference } from "@apollo/client"
import { CRAFTMAN_FRAGMENT } from "../fragment/craftman"

export const updateCacheCraftman = ({
  cache,
  entryData,
  action,
}: {
  cache: ApolloCache<any>
  entryData: any
  action: "update" | "delete" | "add"
}) => {
  return cache.modify({
    fields: {
      users(existing = []) {
        const newCraftmanRef = cache.writeFragment({
          data: entryData,
          fragment: CRAFTMAN_FRAGMENT,
        })
        switch (action) {
          case "add":
            return [...existing, newCraftmanRef]
          case "delete":
            return [
              ...existing?.filter(
                (el: Reference | undefined) =>
                  el?.__ref !== newCraftmanRef?.__ref,
              ),
            ]
          case "update":
            const index = existing.findIndex(
              (el: Reference | undefined) =>
                el?.__ref !== newCraftmanRef?.__ref,
            )
            const items = [...existing]
            if (index > -1) {
              items[index] = newCraftmanRef
            }
            return items
        }
      },
      aggregateUser(existing = {}) {
        let _all = existing?._count?._all
        switch (action) {
          case "add":
            return {
              ...existing,
              _count: {
                ...existing?._count,
                _all: _all ? _all + 1 : 0,
              },
            }
          case "delete":
            return {
              ...existing,
              _count: {
                ...existing?._count,
                _all: _all ? _all - 1 : 0,
              },
            }
        }
      },
    },
  })
}
